const APP_VERSION = '1.11'

export default APP_VERSION;
